/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { ReactComponent as LeftArrow } from "../../../../assets/appearencePage/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../assets/appearencePage/arrow-left-dark.svg";
import { Link } from "react-router-dom";

import { ReactComponent as Fill } from "../../../../assets/InvitationSystem/Fill.svg";
import { ReactComponent as FillDark } from "../../../../assets/InvitationSystem/Fill-dark.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/InvitationSystem/DeleteIcon.svg";

import useLocales from "../../../../hooks/useLocales";

import OgImage from "../../../../assets/landingPages/homePage/Hero.png";
import { Helmet } from "react-helmet";
import useSettings from "../../../../hooks/useSettings";
import { useSelector } from "react-redux";

const InvitionSystemEdit = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [enteredEmails, setEnteredEmails] = useState([
    "user1@example.com",
    "user2@example.com",
    "user3@example.com",
    "user4@example.com",
    "user5@example.com",
  ]);

  const getHeight = () => {
    if (enteredEmails?.length === 0) {
      return "h-[102px]";
    } else {
      return "h-auto";
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>InvitionSystem | Bil.Bio</title>
        <meta property="og:title" content="InvitionSystem | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] overflow-y-auto">
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 smm:px-8 xsmfold:pt-12 pt-28 py-12">
              <div className="flex md:hidden mt-10 mb-[38px] relative items-center pr-6">
                <div className="absolute inset-y-0 flex items-center justify-center">
                  <Link to={"/mDashboard"}>
                    {darkMode ? (
                      <LeftArrowDark
                        className={`h-[20px] w-[20px] ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    ) : (
                      <LeftArrow
                        className={`h-[20px] w-[20px] ${
                          themeDirection === "rtl"
                            ? "transform -scale-x-100"
                            : ""
                        }`}
                      />
                    )}
                  </Link>
                </div>
                <h6 className="w-full text-center text-heading_color dark:text-color_v1_dark text-body_copy1_b">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="hidden mb-[30px] md:flex items-center mt-10 gap-[10px] pl-1">
                <div
                  style={{
                    boxShadow:
                      "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
                  }}
                  className="hidden md:flex justify-center items-center p-[9px] bg-white dark:bg-dark-secondary rounded-lg  "
                >
                  {darkMode ? <FillDark /> : <Fill />}
                </div>
                <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h6">
                  {translate("Invitation_System.invite_friend")}
                </h6>
              </div>
              <div className="w-full bg-white dark:bg-dark-secondary rounded-[10px] md:rounded-[20px] lg:rounded-[30px] p-6 lg:p-[50px] md:mb-[90px]">
                <form>
                  <div className="min-h-[calc(100vh_-_335px)] flex flex-col justify-between overflow-y-scroll">
                    <div>
                      <h6 className="text text-heading_color dark:text-color_v1_dark text-custom_h6">
                        {translate("Invitation_System.invite_friend_cap")}
                      </h6>
                      <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-color_v2_dark">
                        {translate("Invitation_System.you_have")}
                        <span className="px-1" style={{ color: "#FF5349" }}>
                          5
                        </span>
                        {translate("Invitation_System.credits")}
                      </p>
                      <hr className="mt-4 lg:mt-5" />
                      <div>
                        <div>
                          <div className="mt-6 lg:mt-[30px]">
                            <div className="grid gap-5 lg:gap-[30px] mt-6 lg:mt-5 grid-cols-1 lg:grid-cols-3 ">
                              <div className="col-span-2">
                                <label
                                  htmlFor="email"
                                  className="block ms-[15px] mb-2 text-heading_color  dark:text-color_v1_dark text-small2 sm:text-body_copy2 "
                                >
                                  {/* Email */}
                                  {translate("email")}
                                </label>
                                <div className="relative">
                                  <div
                                    className={`${getHeight()} flex w-full flex-wrap sm:py-1.5 sm:px-3 py-[13px] pr-[15px] pl-2.5 items-start content-start sm:gap-1.5 gap-2 border-solid	border border-light_bg_v2 focus:border-font_light_color bg-light_bg_v5 dark:bg-dark-secondary rounded-md`}
                                  >
                                    {enteredEmails.map((email, index) => (
                                      <div
                                        key={index}
                                        className="w-auto	h-auto flex items-start gap-2 px-3 sm:pt-3 sm:pb-2.5 pt-1.5	pb-1 rounded-[20px] border-solid	border border-main_color bg-light_bg_v5 dark:bg-dark-secondary"
                                      >
                                        <p className="text-sm not-italic font-normal tracking-[-0.2px] text-font_light_color dark:text-color_v1_dark">
                                          {email}
                                        </p>
                                        <div className="shrink-0 w-5 h-5 items-center	justify-center flex">
                                          <DeleteIcon />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <button
                                  type="submit"
                                  className="bg-main_color  lg:mt-9 text-white rounded-full h-12 pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-48 w-full"
                                >
                                  {translate(
                                    "Invitation_System.invite_friend_cap"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvitionSystemEdit;
